    import { useSelector } from "react-redux";
    import useVillageActions from "./_actions";

    export const useVillage = () => {
        const {
            fetchVillageList,
            downloadVillageFileUploadTemplate,
            createMultipleVillage,
            getVillageList,
            // addVillage,
            changeCurrentPage, 
            changeRowsPerPage,
            changeSearchTerm,
            changeRegionCodeFilter,
            changeTownshipCodeFilter,
            changeVillageTractCodeFilter,
            changeProfileCompletionFilter,
            refreshDialogState,
            fetchVillageDataSources,
            // editVillage
            createLocationProfile,
            updateLocationProfile,
            getLocationProfileByLocationId
        } = useVillageActions();

        const villages = useSelector(state => state.village.data);
        const currentPage = useSelector(state => state.village.currentPage);
        const totalRows = useSelector(state => state.village.totalRows);
        const rowsPerPage = useSelector(state => state.village.rowsPerPage);
        const isLoading = useSelector(state => state.village.isLoading);
        const isError = useSelector(state => state.village.isError);
        const errorMessage = useSelector(state => state.village.errorMessage);
        const searchTerm = useSelector(state => state.village.searchTerm);
        const regionCodeFilter = useSelector(state => state.village.filters.region_code);
        const townshipCodeFilter = useSelector(state => state.village.filters.township_code);
        const villageTractCodeFilter = useSelector(state => state.village.filters.villageTract_code);
        const apiAction = useSelector(state => state.village.action);
        const profileCompletionFilter = useSelector(state => state.village.filters.profile_completion);

        const dataSources = useSelector((state) => state.village.datasource);
        
        return {
            //state
            villages,
            currentPage,
            totalRows,
            rowsPerPage,
            isLoading,
            isError,
            errorMessage,
            searchTerm,
            regionCodeFilter,
            townshipCodeFilter,
            villageTractCodeFilter,
            profileCompletionFilter,
            apiAction,
            dataSources,
            
            //actions
            fetchVillageList,
            downloadVillageFileUploadTemplate,
            createMultipleVillage,
            getVillageList,
            // addVillage,
            changeCurrentPage,
            changeRowsPerPage,
            changeSearchTerm,
            changeRegionCodeFilter,
            changeTownshipCodeFilter,
            changeVillageTractCodeFilter,
            changeProfileCompletionFilter,
            refreshDialogState,
            // editVillage

            fetchVillageDataSources,
            createLocationProfile,
            updateLocationProfile,
            getLocationProfileByLocationId
        }
    }

    export {default as villageReducer} from './_reducers';